import { render, staticRenderFns } from "./IconCoaching.vue?vue&type=template&id=0b0b1407&scoped=true"
import script from "./IconCoaching.vue?vue&type=script&lang=js"
export * from "./IconCoaching.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0b1407",
  null
  
)

export default component.exports